import { useState, useEffect, useMemo } from "react";
import TicketEntryScanner from "../TicketEntryScanner";
import {useDispatch, useSelector} from "react-redux"
import { fetchSubscribeToTicketsForPayeeCatalog, fetchSubscribeToReceiptsForPayeeCatalog, fetchVerifyReceipt, fetchVerifyTicket } from "../../actions";
import { OBJECT_TYPE_TICKET } from "../../constants/ticket";
import { OBJECT_TYPE_RECEIPT } from "../../constants/receipts";

const EventTicketEntryScanner = ({
    payeeId="",
    payeeCatalogId=""
}) => {
    /** 
     * Purpose: scan digital and physical tickets across multiple products attached to an event catalog
     * 
     * Main function: intelligently load the tickets and receipts for the specified event catalog
     * **/

    //listen to the tickets for this payee catalog 
    const [ticketsListener, setTicketsListener] = useState(()=>()=>{})
    //load all tickets for this payee catalog
    const dispatch = useDispatch()
    const listenToTickets = async () => {
        //listen to tickets
        const newTicketsListener = await dispatch(fetchSubscribeToTicketsForPayeeCatalog(payeeCatalogId, payeeId))
        setTicketsListener(() => newTicketsListener)
    }
    //load tickets on mount to verify physical tickets
    useEffect(() => {
        if (payeeId && payeeCatalogId) listenToTickets()
        return () => {
            if (typeof ticketsListener === "function") ticketsListener()
        }
    }, [
        payeeId,
        payeeCatalogId
    ])
    //listen to the receipts for this payee catalog 
    const [receiptsListener, setReceiptsListener] = useState(()=>()=>{})
    //load all receipts for this payee catalog
    const listenToReceipts = async () => {
        //listen to receipts
        const newReceiptsListener = await dispatch( fetchSubscribeToReceiptsForPayeeCatalog(payeeCatalogId, payeeId))
        setReceiptsListener(() => newReceiptsListener)
    }
    //load receipts on mount to verify digital tickets
    useEffect(() => {
        if (payeeId && payeeCatalogId) listenToReceipts()
        return () => {
            if (typeof receiptsListener === "function") receiptsListener()
        }
    }, [
        payeeId,
        payeeCatalogId
    ])
    //get the tickets currently loaded in state
    const ticketsById = useSelector(state => state.tickets.ticketsById || {})
    const catalogTicketsById = useMemo(() => {
        const catalogTicketsById = {}
        Object.values(ticketsById).forEach(t => {
            if (t.payeeCatalogId === payeeCatalogId){
                catalogTicketsById[t.id] = t
            }
        })
        return catalogTicketsById
    }, [ticketsById, payeeCatalogId])
    //get all of the receipts for this event
    const payeeProductReceiptsByPayeeCatalogId = useSelector(state => state.receipts.payeeProductReceiptsByPayeeCatalogId || {})
    const receiptsById = payeeProductReceiptsByPayeeCatalogId[payeeCatalogId] || {}
    const handleVerify = (verificationId, scanData, objectType) => {
        if (objectType === OBJECT_TYPE_RECEIPT) {
            dispatch(fetchVerifyReceipt(
                scanData.receiptId, 
                scanData.id,
                verificationId
            ))
        } else if (objectType === OBJECT_TYPE_TICKET){
            //mark ticket as verified
            dispatch(fetchVerifyTicket(
                scanData.id, 
                verificationId
            ))
        }
    }
    return <TicketEntryScanner
                payeeId={payeeId} 
                ticketsById={catalogTicketsById}
                receiptsById={receiptsById}
                onVerify={handleVerify}
            />
}

export default EventTicketEntryScanner